module.exports = __webpack_public_path__ + "static/jk-mobile-d30e50c755b298d1eac84e7a18ce1ab7.png";